import React, { useEffect, useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import { CardBody, Button } from 'reactstrap';

import bg from '../../assets/images/bag-tag-bg.png';
import { removeBackground } from '../../helpers/removeBackground';

const ChildBagTagTemplate = ({ imgUrl, childInfo, item }) => {
  const exportRef = useRef();
  const [processedImgUrl, setProcessedImgUrl] = useState(imgUrl);

  useEffect(() => {
  const processImage = async () => {
    if (!imgUrl) return;

    try {
      const response = await fetch(imgUrl);
      const blob = await response.blob();

      const outputBlob = await removeBackground(blob);

      const bgRemovedUrl = URL.createObjectURL(outputBlob);

      setProcessedImgUrl(bgRemovedUrl);
    } catch (e) {
      console.error('BG removal failed:', e);
      setProcessedImgUrl(imgUrl);
    }
  };

  processImage();

  return () => {
    if (processedImgUrl?.startsWith('blob:')) {
      URL.revokeObjectURL(processedImgUrl);
    }
  };
}, [imgUrl]);

  const addressOptions = [
    {
      value:
        'White House, Mahatma Gandhi Rd, near Lakshminarayan Temple, Kandivali West, Mumbai',
      label: 'MG'
    },
    {
      value:
        'Kush Elegante, 2, off New Link Road, RDP 8, Mahavir Nagar, Kandivali (W)',
      label: 'MN'
    },
    {
      value: 'Gorai 2, Borivali West, Mumbai, Maharashtra 400091',
      label: 'GB'
    }
  ];

  const getBranchCode = (batchName) => {
    if (!batchName) return 'MG';

    const name = batchName.toUpperCase();

    if (name.includes('MN')) return 'MN';
    if (name.includes('GB')) return 'GB';
    if (name.includes('MG')) return 'MG';

    return 'MG';
  };

  const getAddressFromBatch = (batchName) => {
    const branch = getBranchCode(batchName);

    const found = addressOptions.find((a) => a.label === branch);

    return found?.value || addressOptions[0]?.value;
  };

  const contactNumber =
    childInfo?.parents?.find((p) => p.relation === 'Mother')?.parent
      ?.phone_number ||
    childInfo?.parents?.find((p) => p.relation === 'Father')?.parent
      ?.phone_number ||
    'N/A';

  const waitForImages = async () => {
    const images = exportRef.current.querySelectorAll('img');

    await Promise.all(
      [...images].map((img) => {
        if (img.complete) return Promise.resolve();

        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        });
      })
    );
  };
    
const captureBagTag = async () => {
  try {
    await document.fonts.ready;

    await waitForImages();

    const canvas = await html2canvas(exportRef.current, {
      scale: 5,
      useCORS: true,
      backgroundColor: null
    });

    const image = canvas.toDataURL('image/png', 1.0);

    const link = document.createElement('a');

    link.download = `${childInfo?.name}-bag-tag.png`;
    link.href = image;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  } catch (err) {
    console.error(err);
  }
};

  const BagTagCard = ({ responsive = false }) => (
    <div
      className="position-relative rounded overflow-hidden shadow-lg"
      style={{
        height: responsive ? 'auto' : '400px',
        width: responsive ? '100%' : '560px',
        maxWidth: responsive ? '700px' : 'unset',
        aspectRatio: '7/5',
        flexShrink: 0,
        containerType: responsive ? 'inline-size' : 'unset'
      }}
    >
      <img
        src={bg}
        alt="background"
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
      />

      {/* CHILD NAME */}

      <div
        style={{
          position: 'absolute',
          top: '22%',
          left: '2.8%',
          width: '44.2%',
          textAlign: 'center'
        }}
      >
        <h1
          style={{
            fontSize: responsive ? '6.2cqw' : '34.72px',
            fontWeight: '900',
            color: '#000',
            lineHeight: '1.1',
            textTransform: 'uppercase'
          }}
        >
          {childInfo?.name}
        </h1>
      </div>

      {/* CHILD IMAGE */}

      <div
        style={{
          position: 'absolute',
          bottom: '0',
          left: responsive?'0.85%':'1.75%',
          width: '42.8%',
          height: '52%',
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-start',
          overflow: 'hidden'
        }}
      >
        {processedImgUrl && (
          <img
            className="export-child-image"
            key={processedImgUrl}
            src={processedImgUrl}
            alt={childInfo?.name}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
              background: 'transparent',
              display: 'block'
            }}
          />
        )}
      </div>

      {/* ADDRESS */}

      <div
        style={{
          position: 'absolute',
          bottom: '7%',
          right: '3.5%',
          width: '40%',
          textAlign: 'center'
        }}
      >
        <p
          style={{
            fontSize: responsive ? '2.8cqw' : '15.68px',
            fontWeight: 'bold',
            color: '#000',
            lineHeight: '1.1',
            marginBottom: responsive ? '1.5cqw' : '8.4px'
          }}
        >
          {getAddressFromBatch(item?.name)}
        </p>

        <p
          style={{
            fontSize: responsive ? '2.8cqw' : '15.68px',
            fontWeight: 'bold',
            color: '#000',
            margin: 0
          }}
        >
          Contact No: {contactNumber}
        </p>
      </div>
    </div>
  );

  return (
    <CardBody className="d-flex flex-column align-items-center">
      {/* Responsive Bag Tag Component which is shown in the UI*/}

      <div className="w-100 d-flex justify-content-center">
        <BagTagCard responsive />
      </div>

      {/* Hidden Bag Tag Component which is being downloaded*/}

      <div
        style={{
          position: 'fixed',
          left: '-99999px',
          top: 0,
          zIndex: -1
        }}
      >
        <div
          ref={exportRef}
          style={{
            width: '580px',
            height: '420px',
            background: '#fff',
            padding: '10px'
          }}
        >
          <BagTagCard />
        </div>
      </div>

      <Button
        color="primary"
        className="mb-3 px-4 py-2 fw-bold mt-3"
        onClick={captureBagTag}
      >
        Download Bag Tag
      </Button>
    </CardBody>
  );
};

export default ChildBagTagTemplate;
